import { Community } from '../community.model';
import { SearchResult } from '../search/models/search-result.model';

export class CommunitySearchResult extends SearchResult<Community> {
}
